import { boronClient } from "../../../../api";
import { useBoronMutation } from "../../../../hooks/http/useBoronMutation";
import { useUpdateSectionKartesCache } from "../../../../hooks/http/useFetchSectionKartes";
import { useUpdateStudentKartesCache } from "../../../../hooks/http/useFetchStudentKartes";

interface DeleteKarteParams {
  studentId: string;
  karteId: string;
}

export const useDeleteKarte = ({ sectionId }: { sectionId: string }) => {
  const { removeKarteFromCache: removeSectionKarteFromCache } =
    useUpdateSectionKartesCache();
  const { removeKarteFromCache: removeStudentKarteFromCache } =
    useUpdateStudentKartesCache();

  return useBoronMutation(
    async ({ studentId, karteId }: DeleteKarteParams) => {
      return await boronClient.DELETE(
        "/api/v1/students/{student_id}/kartes/{karte_hashid}",
        {
          params: {
            path: {
              student_id: studentId,
              karte_hashid: karteId,
            },
          },
        },
      );
    },
    {
      onSuccess: (_, variables) => {
        const { studentId, karteId } = variables;
        // 校舎カルテキャッシュから削除
        removeSectionKarteFromCache(sectionId, karteId);
        // 生徒カルテキャッシュから削除
        removeStudentKarteFromCache(studentId, karteId);
      },
    },
  );
};
